import { useTheme } from '@mui/material';
import { mergeWith, get } from 'lodash-es';
import React, { useMemo } from 'react';
import { getDefaultZoomLocaleKey, getDefaultZoomLocaleMap } from '../i18n';
const defaultZoomLocaleKey = getDefaultZoomLocaleKey();
const defaultZoomLocaleMap = getDefaultZoomLocaleMap();
function getInterpolator(locale, isArray, useElement, prefix) {
    const root = prefix ? locale[prefix] ?? {} : locale;
    const interpolate = (key, args) => {
        const template = (get(root, key) || '');
        // istanbul ignore next
        if (process.env.NODE_ENV === undefined ||
            process.env.NODE_ENV === 'development') {
            if (!template) {
                console.warn(`The locale key ${prefix ? `${prefix}.` : ''}${key} is not defined.`);
            }
        }
        if (!args) {
            return isArray ? [template] : template;
        }
        if (isArray) {
            const result = [];
            template.split(/\{\{([^}]+)\}\}/g).forEach((segment, i) => {
                if (!segment) {
                    return;
                }
                if (useElement) {
                    if (i % 2) {
                        result.push(React.createElement(React.Fragment, { key: i }, args[segment]));
                    }
                    else {
                        result.push(React.createElement(React.Fragment, { key: i }, segment));
                    }
                }
                else {
                    // eslint-disable-next-line no-lonely-if
                    if (i % 2) {
                        result.push(args[segment]);
                    }
                    else {
                        result.push(segment);
                    }
                }
            });
            return result;
        }
        return template.replace(/\{\{([^}]+)\}\}/g, (_, argKey) => `${args[argKey]}`);
    };
    return interpolate;
}
export function useTranslation(prefix) {
    const theme = useTheme();
    const localeMap = theme?.zoomUI?.localeMap;
    const localeKey = theme?.zoomUI?.localeKey ?? defaultZoomLocaleKey;
    const locale = useMemo(() => {
        const merged = mergeWith({}, defaultZoomLocaleMap[defaultZoomLocaleKey], localeMap?.[defaultZoomLocaleKey], defaultZoomLocaleMap[localeKey], localeMap?.[localeKey], (objValue, srcValue) => (srcValue === '' ? objValue : undefined));
        return merged;
    }, [localeKey, localeMap]);
    // We keep the reference stable when locale is not changed
    return useMemo(() => ({
        t: getInterpolator(locale, false, false, prefix),
        translateArray: getInterpolator(locale, true, false, prefix),
        translateElement: getInterpolator(locale, true, true, prefix),
    }), [locale, prefix]);
}
